import React, { Fragment } from 'react';

import usePreCompLocationProgramsDetail from './UsePreCompLocationProgramsDetail';

import PreCompLocationProgramOfferingForm from '../components/forms/PreCompLocationProgramOfferingForm';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const PRIMARY_PROGRAM_MESSAGE = '*Select primary Learn To Swim offering first, you will be able to add additional offerings afterwards';

const PreCompLocationProgramsDetail = () => {
  const {
    isSaving,
    isLoading,
    formState,
    errorState,
    displayDupModalState,
    isFirstProgram,
    onFormValueChanged,
    handleSubmit,
    onBackClicked,
    onDupModalCancelClicked
  } = usePreCompLocationProgramsDetail();

  return (
    <Fragment>
      <Headings.H3>{formState.preCompLocationOfferingId ? 'Edit' : 'Add'} Program Offering</Headings.H3>
      {isFirstProgram === true &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.Bold}>{PRIMARY_PROGRAM_MESSAGE}</p>
          </div>
        </div>
      }
      <form onSubmit={handleSubmit} noValidate>
        <PreCompLocationProgramOfferingForm
          formState={formState}
          errorState={errorState}
          onFormValueChanged={onFormValueChanged}
          onOfferingTypeChanged={formState.preCompLocationOfferingId ? undefined : onFormValueChanged} />
        {errorState.errorOnSubmitAction &&
          <div className="row">
            <div className="col-xs-12">
              <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
            </div>
          </div>}
        <div className="row usas-extra-top-margin  usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={90}
        maxWidth={1020}
        title={'Duplicate Program Offering'}
        displayPopUp={displayDupModalState === true}
        onModalCanceled={onDupModalCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p>Location already has a {formState.programOffering[0]?.name} program offering.</p>
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <SecondaryButton type="button" onClick={onDupModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </Fragment>
  );
};

export default PreCompLocationProgramsDetail;